import { useEffect, useRef, forwardRef, useImperativeHandle } from "react";

const HlsVideo = forwardRef(function HlsVideo({ src, autoPlay, controls, className, onReady, ...props }, ref) {
  const videoRef = useRef(null);
  const hlsRef = useRef(null);

  useImperativeHandle(ref, () => videoRef.current, []);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !src) return;
    const Hls = window.Hls;
    const isHls = /\.m3u8($|\?)/i.test(src);

    if (isHls && Hls && Hls.isSupported()) {
      const hls = new Hls({ enableWorker: true });
      hlsRef.current = hls;
      hls.loadSource(src);
      hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        if (onReady) onReady(hls);
        if (autoPlay) video.play().catch(() => {});
      });
      return () => { hls.destroy(); hlsRef.current = null; };
    } else {
      // Native playback for mp4/webm or Safari HLS
      video.src = src;
      if (autoPlay) video.play().catch(() => {});
    }
  }, [src]); // eslint-disable-line react-hooks/exhaustive-deps

  return <video ref={videoRef} controls={controls} className={className} playsInline {...props} />;
});

export default HlsVideo;
